<template>
	<form @submit.prevent="submit" class="line-banner__table">
		<ManagingSection>
			<ManagingBox title="번호">
				{{ mode === 'register' ? '자동생성' : modifyId }}
			</ManagingBox>
			<ManagingBox :title="titleName">
				<input v-model="title" type="text" />
				<p class="line-banner__table__notice">
					내부 관리를 위한 제목 입력란입니다.(유저에게 미노출)
				</p>
			</ManagingBox>
			<ManagingBox title="타이틀" v-if="this.type === 'home'">
				<TextCounter
					v-model="displayTitle"
					:useTextarea="true"
					:useLineLimit="true"
					:maxLength="25"
				/>
			</ManagingBox>
			<ManagingBox title="디스크립션" v-if="this.type === 'home'">
				<TextCounter
					v-model="description"
					:useTextarea="true"
					:maxLength="200"
				/>
			</ManagingBox>
			<ManagingBox title="노출 여부" :horizontalMode="true">
				<RadioList v-model="isDisplay" :radioList="displayList" />
			</ManagingBox>
			<ManagingBox
				title="광고 여부"
				v-if="this.type === 'home'"
				:horizontalMode="true"
			>
				<RadioList v-model="isAds" :radioList="isAdList" />
			</ManagingBox>
			<ManagingBox title="시작 일시">
				<DateBox v-model="startDate" />
			</ManagingBox>
			<ManagingBox title="종료 일시">
				<DateBox v-model="endDate" />
			</ManagingBox>
			<ManagingBox
				:title="`${this.type === 'home' ? '홈DA 이미지' : '띠배너 이미지'}`"
			>
				<ImageUploader
					ref="imageUploader_1125x216"
					group="init-popup"
					:image-size-limit="{
						width: this.imgWidth,
						height: this.imgHeight,
						previewWidth: 300,
						type: 'fit',
					}"
					@upload="onImageUpload($event, `${imgWidth}x${imgHeight}`)"
					:file-path-has-slash="true"
				/>
				<p class="line-banner__title">
					- 파일형식: PNG(*.png), JPEG(*.jpg) <br />
					- 사이즈: {{ imgWidth }} x {{ imgHeight }}
				</p>
			</ManagingBox>
			<ManagingBox title="링크 설정">
				<RadioList v-model="linked" :radioList="linkedList" />
				<div v-show="linked === 1" class="line-banner__link-setting">
					<label>
						<select
							class="line-banner__link-type"
							v-model="linkType"
						>
							<option
								v-for="item in linkTypeList"
								:key="item.id"
								:value="item.id"
							>
								{{ item.name }}
							</option>
						</select>
					</label>
					<label>
						<input
							type="text"
							v-model="linkValue"
							placeholder="링크값을 입력하세요"
						/>
					</label>
				</div>
			</ManagingBox>
			<div class="line-banner__button">
				<button
					type="submit"
					class="btn btn-blue"
					v-text="mode === 'register' ? '등록' : '수정'"
				/>
				<button
					type="button"
					class="btn"
					v-text="'입력값 초기화'"
					@click="resetInput"
				/>
			</div>
		</ManagingSection>
	</form>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateBox from '@/components/DateBox';
	import ImageUploader from '@/components/ImageUploader';
	import moment from 'moment';
	import TextCounter from '@/components/TextCounter.vue';
	import RadioList from '@/components/RadioList';

	export default {
		name: 'LineBannerRegister',
		props: {
			mode: {
				type: String,
				default: 'register',
			},
			type: {
				type: String,
				default: 'home',
			},
		},
		components: {
			DateBox,
			ManagingSection,
			ManagingBox,
			ImageUploader,
			TextCounter,
			RadioList,
		},
		data() {
			return {
				startDate: '',
				endDate: '',
				isDisplay: 0,
				isAds: 0,
				linked: 0,
				linkValue: null,
				linkType: null,
				modifyId: Number(this.$route.params.idParam),
				title: '',
				displayTitle: '',
				fileDir: '',
				fileSaveName: '',
				imgWidth: this.type === 'home' ? 1029 : 1125,
				imgHeight: this.type === 'home' ? 564 : 216,
				description: '',
				displayList: [
					{ id: 0, value: '미노출' },
					{ id: 1, value: '노출' },
				],
				linkedList: [
					{ id: 0, value: '링크없음' },
					{ id: 1, value: '링크연결' },
				],
				isAdList: [
					{ id: 0, value: 'N' },
					{ id: 1, value: 'Y' },
				],
			};
		},
		computed: {
			...mapState({
				idRegister: state => state.login.idRegister,
			}),
			...mapGetters(['getListAddNull']),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
			titleName() {
				if (this.type === 'home') {
					return '홈DA명';
				}
				if (this.type === 'event') {
					return '이벤트 띠배너명';
				}
				if (this.type === 'product_detail') {
					return '제품상세 띠배너명';
				}
			},
		},
		created() {
			if (this.mode === 'modify') {
				this.getModifyData();
			}
		},
		methods: {
			onImageUpload(event, key) {
				if (!Object.keys(event).length) return;
				this.fileDir = event.fileDir;
				this.fileSaveName = event.fileSaveName;
			},
			isEmpty(target) {
				return !target || target.toString().trim().length === 0;
			},
			getFileName(name) {
				const file = name.split('/').reverse();
				this.fileSaveName = file[0];
				this.fileDir = name.replace(`/${this.fileSaveName}`, '');
			},
			validation() {
				if (this.isEmpty(this.title)) {
					alert(`${this.titleName}을 입력해주세요.`);
					return false;
				}
				if (this.type === 'home' && this.isEmpty(this.displayTitle)) {
					alert('타이틀명을 입력해주세요');
					return false;
				}
				if (!this.startDate) {
					alert('시작일을 입력해 주세요');
					return false;
				}

				if (!this.endDate) {
					alert('종료일을 입력해 주세요');
					return false;
				}

				if (this.startDate && this.endDate) {
					const start = moment(this.startDate).valueOf();
					const end = moment(this.endDate).valueOf();

					if (start > end) {
						alert('종료일시는 시작일시보다 빠를 수 없습니다');
						return false;
					}
				}

				if (!this.$refs.imageUploader_1125x216.key) {
					alert('이미지를 등록해 주세요');
					return false;
				}

				if (this.linked === 1) {
					if (this.isEmpty(this.linkType)) {
						alert('링크종류를 선택해주세요.');
						return false;
					}

					if (this.isEmpty(this.linkValue)) {
						alert('링크값을 입력해주세요.');
						return false;
					}
				}
				return true;
			},
			resetInput() {
				this.title = '';
				this.displayTitle = '';
				this.startDate = '';
				this.endDate = '';
				this.linked = 0;
				this.linkType = null;
				this.linkValue = null;
				this.description = '';
			},
			async getModifyData() {
				try {
					this.$store.commit('toggleSpinner', true);
					const { data } = await this.$axiosAdmin2.get(
						`/api/line-banner/${this.modifyId}`
					);
					this.title = data.title;
					this.displayTitle = data.displayTitle;
					this.startDate =
						data.startAt &&
						moment(data.startAt).format('YYYY-MM-DDTHH:mm');
					this.endDate =
						data.endAt &&
						moment(data.endAt).format('YYYY-MM-DDTHH:mm');
					this.linked = data.linkType ? 1 : 0;
					this.linkType = data.linkType;
					this.isDisplay = data.isDisplay ? 1 : 0;
					this.isAds = data.isAd ? 1 : 0;
					this.linkValue = data.linkValue;
					this.description = data.description;
					data.imgUrl &&
						this.$refs.imageUploader_1125x216.setImageByUrl(
							data.imgUrl
						);
					this.getFileName(this.$refs.imageUploader_1125x216.key);
					this.$store.commit('toggleSpinner', false);
				} catch (err) {
					console.error(err);
					alert(
						'서버와의 통신에 실패하였습니다. 개발팀에 문의하세요.'
					);
					this.$store.commit('toggleSpinner', false);
				}
			},
			async submit() {
				try {
					if (!this.validation()) {
						return false;
					}

					let confirmMessage = '';
					let completeMessage = '';

					if (this.mode === 'register') {
						confirmMessage = '등록하시겠습니까?';
						completeMessage = '등록이 완료되었습니다.';
					} else if (this.mode === 'modify') {
						confirmMessage = '수정하시겠습니까?';
						completeMessage = '수정이 완료되었습니다.';
					}

					if (!confirm(confirmMessage)) {
						return false;
					}

					const params = {
						title: this.title,
						displayTitle: this.displayTitle,
						isDisplay: this.isDisplay === 1,
						idRegister: this.idRegister,
						fileDir: this.fileDir,
						fileSaveName: this.fileSaveName,
						startAt:
							this.startDate &&
							moment(this.startDate, 'YYYY-MM-DDTHH:mm').format(
								'x'
							),
						endAt:
							this.endDate &&
							moment(this.endDate, 'YYYY-MM-DDTHH:mm').format(
								'x'
							),
						width: this.imgWidth,
						height: this.imgHeight,
						linkType: this.linked === 0 ? null : this.linkType,
						linkValue: this.linked === 0 ? null : this.linkValue,
						location: this.type,
						description: this.description,
						isAd: this.isAds === 1,
					};

					if (this.mode === 'modify') {
						params.id = this.modifyId;
					}

					this.$store.commit('toggleSpinner', true);

					const res = await this.$axiosAdmin2.post(
						'/api/line-banner',
						params
					);
					if (res.status === 200) {
						alert(completeMessage);
						this.$router.go(-1);
					}

					this.$store.commit('toggleSpinner', false);
				} catch (err) {
					console.error(err);
					alert(
						'서버와의 통신에 실패하였습니다. 개발팀에 문의하세요.'
					);
					this.$store.commit('toggleSpinner', false);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.line-banner__table {
		.modify {
			width: 300px !important;
		}
		.line-banner__title {
			margin-top: 10px;
		}
		.line-banner__link-setting {
			margin-top: 20px;
		}
		.line-banner__link-type {
			padding: 0 10px;
			height: 35px;
			background: #fff;
			border: solid 1px #dfe6ee;
		}
		.line-banner__table__notice {
			margin-top: 10px;
		}

		.line-banner__button {
			padding: 2em;
			text-align: center;

			.btn {
				display: inline-block;
				min-width: 100px;
				& + .btn {
					margin-left: 10px;
				}
			}

			.btn-blue {
				background: $btn-blue;
				border: 1px solid $btn-blue;
				color: #fff;
			}
		}
	}
</style>
